import React from 'react'
import makmemberphoto from "../images/mak photo member.jpeg";

function About() {
  return (
    <div>
          <div className="album py-3">
                <div className="container">
                    <div className="row">
                        <div className="col-md-8 mt-3">
                                <div className="card-body">
                                    <h1 className="card-title mb-3">About <b>MAK</b></h1>
                                    <h4 className="card-text"><b>Dare to explore the unknown</b> 
                                    </h4>
                                    <h6 className='justify mb-2'>Our organisation Mountaineers’ Association of Krishnanagar (MAK) is a notable
name in the field of mountaineering in India. MAK was established in 1986 and is
located in Krishnanagar, Nadia district, West Bengal, India-741101. It is registered
under the West Bengal Societies Registration Act, 1961 and also affiliated to the
Indian Mountaineering Foundation, New Delhi. Till 2025, MAK has conducted 40
mountaineering expeditions, summiting 29 peaks in the Himalayas. Some of the
major mountain peaks climbed by us include - Mt. Everest (8848.86 m, in 2025 &amp;
2010), Saserkangri-IV (7416 m, in 2018), Mt. Annapurna-I (8091 m, 1st Indian
Civilian Ascent, in 2012), Mt. Kanchenjunga-I (8586 m, 1st Indian Civilian Ascent, in
2011), Mt. Thalaysagar (6904 m, 1st Indian Ascent, in 2008), Mt. Shivling (6543 m,
1st Indian Civilian Ascent, in 2005), Mt. Indrasan (6221 m, 1st Indian Ascent, in
2004), Mt. Shiva (6142 m, 1st Indian Ascent, in 2002), Mt. Bhrigupanth (6772 m, in
1999), Mt. Chowkhamba-I (7138 m, in 1998), Mt. Kamet (7756 m, in 1997), Mt.
Srikailash (6932 m, in 1993), etc. In recognition of outstanding achievements in
adventure on land, two of our members have been awarded the highest adventure
sports award of the Republic of India, “Tenzing Norgay National Adventure Award”
(equivalent to the Arjuna award) in the years 2013 and 2016 respectively. Our annual
activities include organising Rock Climbing Course (age 18-40), Adventure Course
for teenagers (age 14-16), Nature Study Camp for children (age 8-12), High Altitude
Treks, Coastal Treks, Desert Treks, Blood Donation Camps, Rock climbing practices,
etc., aiming to promote environmental awareness and education, love for nature and
the spirit of adventure in society.</h6>
                                
                            </div>
                        </div>
                        <div className="col-md-4 mt-3">
                          <div className='rediusfuchkabanner'>
                                <img src={makmemberphoto} className="card-img-top" alt="makmemberphoto"/>
                               
                                </div>
                            
                        </div>
                    </div>
                </div>
            </div>
    </div>
  )
}

export default About